import { Capacitor } from "@capacitor/core";
import config from "config";

/**
 * Returns the origin (scheme + host [+ port]) that should be used when
 * building user-facing shareable URLs (Go Live, conference join, group
 * invite, etc.).
 *
 * Inside a Capacitor native build, `window.location.origin` is
 * "capacitor://localhost" (or "https://localhost" with
 * `server.iosScheme: 'https'`), which is useless when the link is sent
 * to someone outside the native WebView. We therefore fall back to
 * `config.publicAppUrl` in that case (configured via
 * `REACT_APP_PUBLIC_APP_URL`, or auto-derived from the origin of
 * `REACT_APP_BACKEND_URL` when it is absolute).
 *
 * Trailing slashes on `publicAppUrl` are stripped so callers can safely
 * concatenate a path beginning with "/".
 */
export default function getPublicOrigin(): string {
  if (Capacitor.isNativePlatform() && config.publicAppUrl) {
    return config.publicAppUrl.replace(/\/$/, "");
  }
  return typeof window !== "undefined" ? window.location.origin : "";
}
